__turbopack_context__.v({
  "item": "styles-module__GhcNEG__item",
  "list": "styles-module__GhcNEG__list",
  "serviceTitle": "styles-module__GhcNEG__serviceTitle",
});
